import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
	// A list of all locales that are supported
	locales: ['ko', 'en', 'de', 'es', 'fr', 'id', 'ja', 'mn', 'ms', 'th', 'vi', 'zh-cn', 'zh-tw'],

	// Used when no locale matches
	defaultLocale: 'en',
});

// Export for legacy compatibility
export const locales = routing.locales;
export const defaultLocale = routing.defaultLocale;
export type Locale = (typeof locales)[number];

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
